import * as _ from 'lodash';
import { useMemo } from 'react';

import { useQuery } from '../../../../contexts/RouterContext';
import { useSnippets } from '../../../../hooks/api';
import type { GetSnippetsParams, SnippetsQueryParams } from '../../../../../shared/snippets';

type ClientSideOnlyQueryParams = Exclude<keyof SnippetsQueryParams, keyof GetSnippetsParams>;

const clientSideParams: ClientSideOnlyQueryParams[] = ['selectedSnippetId'];

/**
 * This is a light wrapper around the base useSnippets which pulls in the query params
 * from the URL, removes any client-side only ones (like the `selectedSnippetId` which is for the drawer),
 * and passes them off to useSnippets. Because this is used in the root component and in the drawer, this
 * saves us needing to write this in multiple places.
 *
 * @param {string} userRevisionLocator - The given project revision locator to fetch snippets for.
 */
const useSnippetsWithQueryParams = (userRevisionLocator: string) => {
  const [queryParams] = useQuery<SnippetsQueryParams>();
  //  Remove any FE-only query params
  const getSnippetsQueryParams: GetSnippetsParams = useMemo(() => _.omit(queryParams, clientSideParams), [queryParams]);
  return useSnippets(userRevisionLocator, getSnippetsQueryParams);
};

export default useSnippetsWithQueryParams;
